const styles = {
  container: {
    width: "100%",
  },
  tableBox: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tableBoxNoOverFlow: {
    whiteSpace: "normal", // allow line wrap
    overflow: "visible", // show full content
    wordBreak: "break-word", // break if very long word
  },
  actionBtn: {
    borderRadius: 0,
    fontSize: 12,
    color: "#FB5C5F",
    backgroundColor: "rgb(242, 242, 242)",
    padding: "2px 8px",
  },
  actionButtons: {
    display: "flex",
    gap: 22,
  },
  actionIcon: {
    cursor: "pointer",
  },
  typoghrphyStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.875rem",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default styles;
